var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slice-scroll-point pt-px -mt-px",attrs:{"id":_vm.kb(_vm.slice.heading)}},[_c('h2',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.slice.heading))])])
}
var staticRenderFns = []

export { render, staticRenderFns }